const integer = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(value);
  return Number.isInteger(number) ? number : null;
};

export function normalizeCameraList(response) {
  const groups = Array.isArray(response) ? response : response?.data;
  if (!Array.isArray(groups))
    throw new Error("La respuesta no contiene una lista de cámaras válida.");
  return groups.map((group) => {
    if (typeof group?.name !== "string" || !Array.isArray(group.cameras)) {
      throw new Error("El comercio recibido no tiene una lista de cámaras válida.");
    }
    return {
      name: group.name,
      cameras: group.cameras.map((camera) => ({
        hostid: String(camera.hostid ?? ""),
        name: camera.name || camera.host || "Cámara sin nombre",
        host: camera.host || "",
        name_upper: camera.name_upper || "",
        ip: camera.ip || "",
        dns: camera.dns || "",
        port: camera.port || "",
        useip: integer(camera.useip),
        status: integer(camera.status),
        available: integer(camera.available),
        maintenance_status: integer(camera.maintenance_status),
        error: typeof camera.error === "string" ? camera.error : "",
        commerceName: group.name,
      })),
    };
  });
}

export function cameraAvailability(camera) {
  if (camera?.available === 1) return { label: "Con alcance", color: "success" };
  if (camera?.available === 2) return { label: "Sin alcance", color: "error" };
  return { label: "Sin verificar", color: "default" };
}

export function matchesCamera(camera, filters) {
  const search = filters.busqueda.trim().toLocaleLowerCase();
  return (
    (!filters.comercio || camera.commerceName === filters.comercio.name) &&
    (!search ||
      [camera.name, camera.ip, camera.commerceName].some((v) =>
        v.toLocaleLowerCase().includes(search)
      )) &&
    (!filters.ip || camera.ip.includes(filters.ip.trim())) &&
    (filters.estado === "todos" ||
      (filters.estado === "disponibles" && camera.available === 1) ||
      (filters.estado === "sinAlcance" && camera.available === 2) ||
      (filters.estado === "desconocidos" && ![1, 2].includes(camera.available)))
  );
}

export function cameraMetric(value) {
  if (
    value === null ||
    value === undefined ||
    String(value).trim() === "" ||
    value === "No disponible"
  )
    return null;
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : null;
}

export function formatCameraDate(value) {
  if (!value) return "Sin información";
  if (!/(Z|[+-]\d{2}:?\d{2})$/i.test(String(value))) return String(value);
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Sin información";
  return new Intl.DateTimeFormat("es-CO", {
    timeZone: "America/Bogota",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(date);
}
